"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rignano-flaminio": {
    "ae81a9d0": [{
      "hkey": "cc869451",
      "slug": "montelarco",
      "name": "Montelarco",
      "primary": true,
      "skipSearch": false
    }],
    "montelacro": [{
      "hkey": "cc869451",
      "slug": "montelarco",
      "name": "Montelarco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;